export { default as SoundPopup } from './SoundPopup';